var map = {
	"./base-init.conf.ts": 4241,
	"./baseConfiguration.ts": 48194,
	"./baseSelectorConfiguration.ts": 76513,
	"legacy/customer/base/brandbase/base-init.conf.ts": 4241,
	"legacy/customer/base/brandbase/baseConfiguration.ts": 48194,
	"legacy/customer/base/brandbase/baseSelectorConfiguration.ts": 76513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10610;